import React, { useState, useContext } from 'react';

import {
 useNavigate,  Outlet
} from "react-router-dom";

import { useCallback, useMemo } from 'react';
import { useLocation  } from 'react-router';
import { useModuleHistoryData} from './contexts/module-history-context';

import { TwoFactorLogin } from './components/two-factor-login';
import { TwoFactorPrompt } from './components/two-factor-prompt';

import {useUserContext} from "./contexts/user-context";
import {Badge, Box, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, styled, Tooltip, useTheme} from "@mui/material";
import UploadIcon from '@mui/icons-material/Upload';
import {
  AccountCircle,
  Business,
  DashboardOutlined,
  GridView, LogoutOutlined,
  People, Settings,
  Shield,
  ShowChart, Storage,
  ViewList, Work, MenuBookTwoTone, Tv, Construction, Brush
} from "@mui/icons-material";
import WaitSpinner from './components/wait-spinner';
import Login from "./components/login";
import Toolbar from "./components/toolbar";
import challengeIcon from '@iconify/icons-mdi/sword-cross';
import { Icon } from '@iconify/react';
import { useDaybookContext } from './contexts/Daybook/DayBookContext';
export const HollywoodContext = React.createContext(null);
const menu = [
  {key:'/',text:'Dashboard',icon:<DashboardOutlined sx={{color:'#FFF'}}/>,tooltip:'Dashboard - Campaign Shortcuts and Sales reports',urls:['/sales','/']},
  {key:'/campaigns',text:'Campaigns',icon:<ViewList sx={{color:'#FFF'}}/>,urls:['/campaigns'],tooltip:'Campaigns - Create/delete and manage campaigns',permission:'campaigns.view'},
  {key:'/cs-campaigns',text:'CS Campaigns',icon:<Brush sx={{color:'#FFF'}}/>,urls:['/cs-campaigns'],tooltip:'CS Campaigns - Creative Studio campaigns',permission:'campaigns.view'},
  {key:'/panel-bookings',text:"Panel Bookings",icon:<GridView sx={{color:'#FFF'}}/>,urls:['/panel-bookings'],tooltip:"Panel Bookings - manage panel bookings",permission:'panelbookings.view'},
  {key:'/digital-bookings',text:"Digital Bookings",icon:<Tv sx={{color:'#FFF'}}/>,urls:['/digital-bookings'],tooltip:"Digital Bookings - manage digital screens bookings",permission:'digitalbookings.view'},
  {key:'/contacts',text:'Contacts',icon:<People sx={{color:'#FFF'}}/>,tooltip:'Contacts',permission:'contacts.view'},
  {key:'/companies',text:'Companies',icon:<Work sx={{color:'#FFF'}}/>,tooltip:'Companies',permission:'companies.view'},
  {key:'/sites',text:'Sites',icon:<Business sx={{color:'#FFF'}}/>,tooltip:'Sites',permission:'sites.view'},
  {key:'/sites-maintenance',text:'Maintenance & Inspection Log',icon:<MenuBookTwoTone sx={{color:'#FFF'}}/>,tooltip:'Maintenance & Inspection Log',permission:'sites.create_maintenance_logs'},
  {key:'/reports',text:'Reports',icon:<ShowChart sx={{color:'#FFF'}}/>,tooltip:'Reports',permission:'reports.run'},
  {key:'/imports',text:'Imports',icon:<UploadIcon sx={{color:'#FFF'}}/>,tooltip:'Imports',permission:'imports.run'},
  {divider:true},
  {key:'/database',text:'Options',tooltip:'Options',icon:<Storage sx={{color:'#FFF'}}/>,permission:'section.database'},
  {key:'/settings',text:'Settings',tooltip:'Settings',icon:<Settings sx={{color:'#FFF'}}/>,permission:'section.settings'},
  {key:'/tools',text:'Tools',tooltip:'Tools',icon:<Construction sx={{color:'#FFF'}}/>,permission:'section.tools'},
  {divider:true},
  {key:'/me',text:'My account',tooltip:'My Account',icon:<AccountCircle sx={{color:'#fff'}}/>},
  {key:'/my-challenges',text:'Challenges',icon:<Icon icon={challengeIcon} color="#fff" fontSize={20}/>,tooltip:'Challenges'},
  {key:'/challenges',text:'Notifications',icon:<Shield sx={{color:'#FFF'}}/>,tooltip:'Notifications'},
  {key:'/logout',text:'Logout',tooltip:'Logout',icon:<LogoutOutlined sx={{color:'#FFF'}}/>}
];



const HollywoodLayout = styled('div', {
  name: 'HollywoodLayout', slot: 'root',
  shouldForwardProp: (prop) =>
      prop !== 'error' && prop !== 'color' && prop !== 'variant' && prop !== 'sx',
  overridesResolver: (props, styles) => [
    styles.root
  ],
})({});


const Hollywood = () => {
  console.log('render hollywood');
  const [collapsed, setCollapsed] = useState(true);
  const theme = useTheme();
  //  const [pathName, setPathName] = useState(false);
  const getModuleHistory = useModuleHistoryData();
  const toggle = useCallback(() => {
    setCollapsed(!collapsed);
  }, [collapsed]);
  const navigate = useNavigate();
  const userContext = useUserContext();
  const location = useLocation();
  const daybook = useDaybookContext();
  console.log('userContext is', userContext);
  const goto = useCallback((moduleUrl) => () => {
    console.log('callback', moduleUrl);
      let moduleName = '/'+(moduleUrl.replace('/', ''));
      if(moduleName=='/') { moduleName = '/sales'; }
      const moduleHistory = getModuleHistory(moduleName);
      const url = moduleHistory || moduleUrl;
      console.log('navigate',moduleName,moduleHistory,url);
      navigate(url);
  }, [navigate, getModuleHistory]);
  const doLogout = useCallback(() => {
    userContext.doLogout();
    return null;
  }, [userContext]);
  console.log('H2 render outer');
  return useMemo(() => {
//      <Redirect from="/" to="/sales" exact={true} />
    console.log('H2 render memoed',userContext);
    if (userContext?.isLoggedIn === null) {
      return <WaitSpinner variant="overlay" />;
    }
    console.log('H2 USER CONTEXT',userContext);
    console.log('H2 render memoed','done login',userContext);
    if(userContext?.isError) {
      console.log('H2 error context outer',userContext?.errorMessage);
      if(userContext.errorMessage=='2FA-REQUIRED') {
        return <TwoFactorLogin />;
      }
      if(userContext.errorMessage=='2FA-REGISTER-REQUIRED') {
          return <TwoFactorPrompt />;
      }
      console.log('H2 error context - show login');
      return <Login />;
    }
    if (!userContext ||!userContext.isLoggedIn) {
      return <Login />;
    }
      const urlPath = location.pathname.split('/');
      const url = (urlPath.length > 1) ? '/' + urlPath[1] : '/';
    return (
      <HollywoodLayout className={'hly-layout ' + (collapsed ? 'has-collapsed' : '')}>
        <div className={'hly-layout__sidebar bp3-dark ' + (collapsed ? 'collapsed' : '')} style={{background:(theme?.components as any)?.Daybook?.defaultProps?.sidebarBackground}}>
          <div className="hly-layout__sidebar__top"><Tooltip title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}>
            <img style={{ cursor: "pointer" }} alt="" src={collapsed ? (theme?.components as any)?.Daybook?.defaultProps?.logoCollapsed: (theme?.components as any)?.Daybook?.defaultProps?.logo} onClick={toggle} /></Tooltip>
          </div>
          <Box
              sx={{ width: collapsed?80:200 }}
              role="presentation"
          >
            <List sx={{color:'#FFF'}}>
              {menu.map((item,idx) => {
                if(item.divider) {
                  return <Divider key={'divider-'+idx} color="#000" light={true} />;
                }
                if(item.permission && !userContext.hasPermission(item.permission)) {
                  return null;
                }
                return (
                    <ListItem key={item.key} disablePadding>
                      <Tooltip title={item.tooltip} placement="right">
                      <ListItemButton onClick={goto(item.key)} selected={url===item.key || (item.urls && item.urls.indexOf(url)>-1)}>
                        <ListItemIcon>
                          {daybook?.challengeEnabled && item.key=='/my-challenges' &&
                          <Badge badgeContent={userContext?.challengeCountOutboundNew>0?userContext?.challengeCountOutboundNew:userContext?.activeChallengeCountOutbound} color={userContext?.challengeCountOutboundNew?'warning':'primary'}>{item.icon}</Badge>
                          }
                          {daybook?.challengeEnabled && item.key=='/challenges' &&
                          <Badge badgeContent={userContext?.challengeCountInboundNew?userContext?.challengeCountInboundNew:userContext?.activeChallengeCountInbound} color={userContext?.challengeCountInboundNew?'warning':'primary'}>{item.icon}</Badge>
                          }
                          {item.key!='/my-challenges'&&item.key!='/challenges' && item.icon}
                        </ListItemIcon>
                        {!collapsed &&
                            <ListItemText primary={item.text}/>
                        }
                      </ListItemButton></Tooltip>
                    </ListItem>);
                  }
              )}
            </List>
          </Box>
        </div>

        <div className="hly-layout__header bp3-dark" style={{background:(theme?.components as any)?.Daybook?.defaultProps?.toolbarBackground}}>
          <Toolbar />
        </div>
        <div className="hly-layout__content">
            <Outlet/>
        </div>
      </HollywoodLayout>
    );
  }, [collapsed, doLogout, goto, location.pathname, toggle, userContext?.isError, userContext?.isLoading,userContext.hasAuthenticatorCode,theme]);
};


export default Hollywood;
